type BroadcastWindow = {
  start_datetime: string;
  end_datetime: string;
};

/**
 * Mirrors the backend rule that rejects the clip otherwise
 * (ClipWithoutProgramBroadcastException): a cut must overlap the emission it
 * belongs to. Segments can start before the emission does, so the first seconds
 * of the player are not always a valid place to open a cut.
 */
function cutOverlapsBroadcast(
  cutStart: Date | null,
  cutEnd: Date | null,
  broadcast?: BroadcastWindow | null
): boolean {
  if (!cutStart || !cutEnd || !broadcast) return true;

  const broadcastStart = new Date(broadcast.start_datetime).getTime();
  const broadcastEnd = new Date(broadcast.end_datetime).getTime();

  if (Number.isNaN(broadcastStart) || Number.isNaN(broadcastEnd)) return true;

  return broadcastStart <= cutEnd.getTime() && broadcastEnd >= cutStart.getTime();
}

export { cutOverlapsBroadcast };
